export const PATHS = {
  // console
  ybConsoleOpsLog: "/console/ops-log",

  // playground
  ybConsoleHomeDashboard: "/playground/console-overview-mockup/:pubId",
  ybConsoleHomeDashboardReseller:
    "/playground/console-overview-mockup-reseller/:pubId",

  // tools
  batchUpdate: "/tools/batch-update-auto-pilot-config",
  gptRequestsComparison: "/tools/gpt-requests-comparison",
  dxDyTrends: "/tools/dx-dy-trends",

  // control-center (ap configs)
  controlCenter: "/control-center",

  // auto pilot segment research configs
  segmentResearch: "/segment-research",

  // ops-mgmt
  opsManagement: "/ops-mgmt",

  // healthcheck
  reportingStatus: "/healthcheck/reporting-status",

  // biz
  bizOverview: "/biz/overview",
  bizNetwork: "/biz/network/:networkId",
  intowowRevenue: "/revenue/overview",
  intowowBilling: "/billing/overview",

  intowowBusiness: "/business",
  // businessBilling: "/business/billing",

  // unit-insight
  unitInsight: "/unit-insight/:unitId",

  // cst-report
  cstReport: "/cst/report/:networkId",

  // snapshot
  snapshot: "/snapshot/:snapshotKey",
  snapshotLatest: "/snapshot/latest",
  yieldSetSnapshot: "/network/:networkId/yield-set-snapshot",

  // observer
  observer: "/observer/:unitId",
  anatomy: "/anatomy/:unitId", // just a rename for observer
  anatomyDebug: "/anatomy/debug/:expId",

  // cst
  anatomyCST: "/anatomy/cst/:unitId",

  // vse
  vseBase: "/vse",

  diagnoserBase: "/diagnoser",

  // vault
  vaultBase: "/vault-accounts",

  // users
  usersBase: "/vault-users",

  // units search
  unitsSearch: "/network/:networkId/units/search",

  pricingRules: "/network/:networkId/pricing-rules",

  // app-configurator
  appConfigurator: "/app-configurator",

  // inventory-rev
  inventoryRev: "/inventory-rev-analysis-dashboard",

  // integration-verification
  integrationVerify: "/integration-verification/:report",

  // competitors-summary
  competitorSummary: "/competitors-summary",

  // virtual placements
  virtualPlacements: "/ops-mgmt/account/network/:networkId/virtual-placements",
  // onboard-inventory
  onboardInventory: "/publisher/:publisherId/onboard",
  // cross check sheet
  crossCheckSheet: "/cross-check-sheet/:networkId",
  // demand portfolio
  demandPortfolio: "/demand-portfolio",
};

export const RELOAD_PATHS = [
  PATHS.ybConsoleHomeDashboard,
  PATHS.ybConsoleHomeDashboardReseller,
  PATHS.bizNetwork,
  PATHS.unitInsight,
  PATHS.cstReport,
  PATHS.snapshot,
  PATHS.yieldSetSnapshot,
  PATHS.unitsSearch,
  PATHS.pricingRules,
  PATHS.integrationVerify,
  PATHS.virtualPlacements,
  PATHS.onboardInventory,
  PATHS.crossCheckSheet,
  "/control-center/unit/:unitId/auto-pilot/config",
  "/control-center/network/:networkId/auto-pilot/config",
  "/diagnoser/network/:networkId",
  "/network/:networkId/pricing-rules/uprs",
  "/network/:networkId/pricing-rules/first-look-rules",
  "/ops-mgmt/account/network/:networkId/update-ad-serving-cost",
  "/ops-mgmt/account/network/:networkId/upr-setting",
  "/ops-mgmt/account/network/:networkId/first-look-setting",
  "/ops-mgmt/account/network/:networkId/upr-segmentation",
  "/ops-mgmt/account/network/:networkId/cst-config",
  "/ops-mgmt/account/network/:networkId/features",
  "/ops-mgmt/account/network/:networkId/code-snippet",
  "/ops-mgmt/account/network/:networkId/prebid-settings",
  "/ops-mgmt/account/network/:networkId/prebid-summary",
  "/ops-mgmt/account/network/:networkId/ac-raw-config",
  "/ops-mgmt/account/network/:networkId/yield-sets",
  "/ops-mgmt/account/publisher/:pubId/update-trial-status",
  "/ops-mgmt/account/publisher/:pubId/features",
  "/ops-mgmt/account/publisher/:publisherId/billing-setting",
  "/ops-mgmt/account/publisher/:publisherId/pricing-config",
  "/ops-mgmt/account/publisher/:publisherId/ac-raw-config",
  "/ops-mgmt/account/publisher/:publisherId/gam-accounts",
  "/ops-mgmt/billing/payment/:paymentId/receive",
];

// To add a new route with title replacing document.title:
// 1. Specify the `path` (e.g., "/new-route/:param").
// 2. Define the `title` using placeholders for any dynamic parameters (e.g., "Page Title {param}").
// Example routes:
// { path: PATHS.snapshot, title: "Ops Log {snapshotKey}" },
// { path: PATHS.yieldSetSnapshot, title: "TEST Log {networkId} 12333" }
export const routes = [
  {
    path: PATHS.appConfigurator,
    title: "App Configurator | YB Observer",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/upr-setting",
    title: "{networkId} Network Custom UPR | YB Observer",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/first-look-setting",
    title: "{networkId} Network Custom First Look Rule | YB Observer",
  },
  {
    path: PATHS.unitsSearch,
    title: "Search Units of {networkId} | YB Observer",
  },
  {
    path: PATHS.inventoryRev,
    title: "Inventory and Revenue Analysis Dashboard | YB Observer",
  },
  {
    path: PATHS.integrationVerify,
    title: "Integration Verification | YB Observer",
  },
  {
    path: "/ops-mgmt/account/publisher/:publisherId/gam-accounts",
    title: "{publisherId} Onboard GAM Account | YB Observer",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/yield-sets",
    title: "{networkId} Onboard Yield Set | YB Observer",
  },
  {
    path: "/ops-mgmt/account/onboard-ad-units",
    title: "Onboard Ad Units",
  },
  {
    path: "/ops-mgmt/account/networks",
    title: "Networks | YB Observer",
  },
  {
    path: "/ops-mgmt/account/onboard-ad-units-tree-view",
    title: "Onboard Ad Units Tree View",
  },
  {
    path: "/ops-mgmt/account/ad-units-batch-actions",
    title: "Ad Units Batch Actions",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/features",
    title: "{networkId} Network Features | YB Observer",
  },
  {
    path: PATHS.vaultBase,
    title: "Vault GAM Accounts | YB Observer",
  },
  {
    path: PATHS.competitorSummary,
    title: "Competitor Summary | YB Observer",
  },
  {
    path: PATHS.batchUpdate,
    title: "Batch Update AP Configs | YB Tools",
  },
  {
    path: "/network/:networkId/pricing-rules/uprs",
    title: "{networkId} GAM UPRs | YB Observer",
  },
  {
    path: PATHS.anatomyCST,
    title: "A:{unitId} | CST Anatomy",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/upr-segmentation",
    title: "{networkId} Network UPR Segmentation Config | YB Observer",
  },
  {
    path: PATHS.virtualPlacements,
    title: "{networkId} Network Virtual Placements | YB Observer",
  },
  {
    path: "/ops-mgmt/account/publishers",
    title: "Publishers | YB Observer",
  },
  {
    path: PATHS.onboardInventory,
    title: "{publisherId} Onboard Inventory | YB Observer",
  },
  {
    path: PATHS.crossCheckSheet,
    title: "{networkId} Cross Check Sheet | YB Observer",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/prebid-summary",
    title: "{networkId} Prebid Summary | YB Observer",
  },
  {
    path: PATHS.unitInsight,
    title: "I:{unitId} | Unit Insight",
  },
  {
    path: "/network/:networkId/pricing-rules/first-look-rules",
    title: "{networkId} First Look Rules | YB Observer",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/cst-config",
    title: "{networkId} Network CST Config | YB Observer",
  },
  {
    path: "/ops-mgmt/account/network/:networkId/code-snippet",
    title: "{networkId} Network Code Snippet | YB Observer",
  },
  {
    path: PATHS.demandPortfolio,
    title: "Demand Portfolio | YB Observer",
  },
  {
    path: PATHS.snapshot,
    title: "Lastest Snapshot | YB Observer",
  },
  {
    path: "/ops-mgmt/account/publisher/:pubId/features",
    title: "{pubId} Publisher Features | YB Observer",
  },
  {
    path: "/control-center/unit/:unitId/auto-pilot/config",
    title: "{unitId} Unit Auto Pilot Config | YB Control Center",
  },
  {
    path: "/control-center/network/:networkId/auto-pilot/config",
    title: "{networkId} Network Auto Pilot Config | YB Control Center",
  },
];

export function pathToRegex(path) {
  const regexString = path
    .replace(/:([^\s/]+)/g, "(?<$1>[^/]+)")
    .replace(/\//g, "\\/");
  return new RegExp(`^${regexString}$`);
}

export function parseTitle({ path, title }, pathname) {
  const regex = pathToRegex(path);
  const params = extractParams(regex, pathname);
  return formatTitle(title, params);
}

function extractParams(regex, pathname) {
  const match = pathname.match(regex);
  return match ? match.groups : null;
}

function formatTitle(template, params) {
  return template.replace(
    /{([^\s{}]+)}/g,
    (_, key) => params[key] || `{${key}}`
  );
}
